const prefixCls = 'web.sales.';

export const localesSales = {
  // 页面标题
  [prefixCls + 'title.list']: {
    zh_CN: '销售列表',
    en_GB: 'Sales List',
  },
  [prefixCls + 'title.detail']: {
    zh_CN: '销售详情',
    en_GB: 'Sales Details',
  },
  [prefixCls + 'title.analysis']: {
    zh_CN: '销售分析',
    en_GB: 'Sales Analysis',
  },

  // 表格列名
  [prefixCls + 'table.column.image']: {
    zh_CN: '图片',
    en_GB: 'Image',
  },
  [prefixCls + 'table.column.sku']: {
    zh_CN: 'SKU',
    en_GB: 'SKU',
  },
  [prefixCls + 'table.column.psku']: {
    zh_CN: 'PSKU',
    en_GB: 'PSKU',
  },
  [prefixCls + 'table.column.orderCount']: {
    zh_CN: '订单数量',
    en_GB: 'Order Count',
  },
  [prefixCls + 'table.column.totalAmount']: {
    zh_CN: '总金额 ({currency})',
    en_GB: 'Total Amount ({currency})',
  },
  [prefixCls + 'table.column.platformFee']: {
    zh_CN: '平台抽成总金额 ({currency})',
    en_GB: 'Platform Fee ({currency})',
  },
  [prefixCls + 'table.column.averagePrice']: {
    zh_CN: '平均售价 ({currency})',
    en_GB: 'Average Price ({currency})',
  },
  [prefixCls + 'table.column.returnRate']: {
    zh_CN: '退货率',
    en_GB: 'Return Rate',
  },
  [prefixCls + 'table.column.date']: {
    zh_CN: '日期',
    en_GB: 'Date',
  },
  [prefixCls + 'table.column.orderNumber']: {
    zh_CN: '订单号',
    en_GB: 'Order Number',
  },
  [prefixCls + 'table.column.customer']: {
    zh_CN: '客户',
    en_GB: 'Customer',
  },

  // 筛选条件
  [prefixCls + 'filter.orderStatus']: {
    zh_CN: '订单状态',
    en_GB: 'Order Status',
  },
  [prefixCls + 'filter.searchPlaceholder']: {
    zh_CN: '搜索SKU/PSKU',
    en_GB: 'Search by SKU/PSKU',
  },
  [prefixCls + 'filter.dateRange']: {
    zh_CN: '日期范围',
    en_GB: 'Date Range',
  },
  [prefixCls + 'filter.amount']: {
    zh_CN: '金额范围',
    en_GB: 'Amount Range',
  },
  [prefixCls + 'filter.platform']: {
    zh_CN: '销售平台',
    en_GB: 'Sales Platform',
  },

  // 状态文本
  [prefixCls + 'status.all']: {
    zh_CN: '全部',
    en_GB: 'All',
  },
  [prefixCls + 'status.completed']: {
    zh_CN: '已完成',
    en_GB: 'Completed',
  },
  [prefixCls + 'status.processing']: {
    zh_CN: '处理中',
    en_GB: 'Processing',
  },
  [prefixCls + 'status.cancelled']: {
    zh_CN: '已取消',
    en_GB: 'Cancelled',
  },
  [prefixCls + 'status.refunded']: {
    zh_CN: '已退款',
    en_GB: 'Refunded',
  },
  [prefixCls + 'status.shipped']: {
    zh_CN: '已发货',
    en_GB: 'Shipped',
  },
  [prefixCls + 'status.pending']: {
    zh_CN: '待处理',
    en_GB: 'Pending',
  },

  // 操作按钮文本
  [prefixCls + 'action.viewDetail']: {
    zh_CN: '查看详情',
    en_GB: 'View Details',
  },
  [prefixCls + 'action.export']: {
    zh_CN: '导出数据',
    en_GB: 'Export Data',
  },
  [prefixCls + 'action.print']: {
    zh_CN: '打印订单',
    en_GB: 'Print Order',
  },
  [prefixCls + 'action.refund']: {
    zh_CN: '申请退款',
    en_GB: 'Request Refund',
  },
  [prefixCls + 'filter.skuPlaceholder']: {
    zh_CN: '搜索SKU',
    en_GB: 'Search SKU',
  },
  // 汇总信息
  [prefixCls + 'summary.totalAmount']: {
    zh_CN: '总金额: {amount} ({currency})',
    en_GB: 'Total Amount: {amount} ({currency})',
  },
  [prefixCls + 'summary.totalOrders']: {
    zh_CN: '总订单数: {count}',
    en_GB: 'Total Orders: {count}',
  },
  [prefixCls + 'summary.averageAmount']: {
    zh_CN: '平均订单金额: {amount} ({currency})',
    en_GB: 'Average Order Amount: {amount} ({currency})',
  },
  [prefixCls + 'summary.totalTax']: {
    zh_CN: '总税额: {amount} ({currency})',
    en_GB: 'Total Tax: {amount} ({currency})',
  },

  // 图表相关文本
  [prefixCls + 'chart.title.daily']: {
    zh_CN: '日销售趋势',
    en_GB: 'Daily Sales Trend',
  },
  [prefixCls + 'chart.title.monthly']: {
    zh_CN: '月销售趋势',
    en_GB: 'Monthly Sales Trend',
  },
  [prefixCls + 'chart.title.distribution']: {
    zh_CN: '销售分布',
    en_GB: 'Sales Distribution',
  },
  [prefixCls + 'chart.xAxis.date']: {
    zh_CN: '日期',
    en_GB: 'Date',
  },
  [prefixCls + 'chart.yAxis.amount']: {
    zh_CN: '金额 ({currency})',
    en_GB: 'Amount ({currency})',
  },
  [prefixCls + 'chart.yAxis.count']: {
    zh_CN: '订单数',
    en_GB: 'Order Count',
  },
  [prefixCls + 'sync.success']: {
    zh_CN: '同步成功',
    en_GB: 'Sync Success',
  },
  [prefixCls + 'sync.failed']: {
    zh_CN: '同步失败',
    en_GB: 'Sync Failed',
  },
  [prefixCls + 'sync.selectAccount']: {
    zh_CN: '请先选择账号',
    en_GB: 'Please select an account',
  },

  // 错误信息
  [prefixCls + 'error.fetchFailed']: {
    zh_CN: '获取销售列表失败',
    en_GB: 'Failed to fetch sales list',
  },
  [prefixCls + 'error.exportFailed']: {
    zh_CN: '导出数据失败',
    en_GB: 'Failed to export data',
  },
  [prefixCls + 'error.detailFailed']: {
    zh_CN: '获取销售详情失败',
    en_GB: 'Failed to fetch sales details',
  },

  // 销量统计
  [prefixCls + 'table.column.salesStatistics']: {
    zh_CN: '销量统计',
    en_GB: 'Sales Statistics',
  },
};
